(function (Drupal, drupalSettings) {
  Drupal.behaviors.collapse = {
    attach: function (context, settings) {
      const buttons = context.querySelectorAll(".collapse-button");
      buttons.forEach((button) => {
        if (!button.dataset.collapseProcessed) {
          button.dataset.collapseProcessed = "true";
          button.addEventListener("click", function () {
            const parent = button.parentElement;
            const collapseElement = parent.nextElementSibling;
            const collapseBody =
              collapseElement.querySelector(".collapse-body");

            parent.classList.toggle("open");

            if (parent.classList.contains("open")) {
              const hBlock = collapseBody.offsetHeight;
              collapseElement.style.maxHeight = `${hBlock}px`;
            } else {
              collapseElement.style.maxHeight = "0";
            }
          });
        }
      });
    },
  };
})(Drupal, drupalSettings);
